export const WEBSITE_URL = "https://admin.amber.coffeeinc.in";
